import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { PacienteService } from "app/services/paciente.service";

@Component({
  selector: "app-fusionar-paciente-dialog",
  templateUrl: "./fusionar-paciente-dialog.component.html",
})
export class FusionarPacienteDialogComponent {
  busqueda: string = "";
  candidatos: any[] = [];
  seleccionado: any = null;
  cargando: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<FusionarPacienteDialogComponent>,
    private pacienteService: PacienteService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pacienteService.listar().subscribe((lista: any[]) => {
      this.candidatos = lista.filter(
        (p) => p.id !== this.data.pacienteId && p.origen !== "dicom"
      );
    });
  }

  get filtrados(): any[] {
    const texto = this.busqueda.trim().toUpperCase();
    if (texto.length < 2) {
      return [];
    }

    return this.candidatos
      .filter(
        (p) =>
          String(p.nombreApellido || "")
            .toUpperCase()
            .includes(texto) ||
          String(p.numeroDocumento || "")
            .toUpperCase()
            .includes(texto)
      )
      .slice(0, 20);
  }

  confirmar() {
    if (!this.seleccionado) {
      return;
    }

    this.cargando = true;
    this.pacienteService
      .fusionar(this.data.pacienteId, this.seleccionado.id)
      .subscribe(
        (r: any) => {
          this.cargando = false;
          this.dialogRef.close(r);
        },
        (error) => {
          this.cargando = false;
          this.dialogRef.close({
            error: error?.error?.error || "No se pudo fusionar",
          });
        }
      );
  }
}
